import React from "react";

const ResumeCard = ({ badge, title, subTitle, des }) => {
  return (
    <div className="w-full py-6 flex flex-col gap-2.5 border-b-[1px] border-b-lineColor">
      {/* Below "lgl": the pill sizes to its own text (dates like "Feb 2026 –
          Present" don't fit the fixed w-24 box). At "lgl" and up: unchanged,
          the original fixed-width, wrapping pill. */}
      <h6 className="w-fit max-w-full whitespace-nowrap px-2.5 lgl:w-24 lgl:px-0 lgl:whitespace-normal text-center text-sm py-[1px] text-faintColor border-[1px] border-lineSoft rounded-sm">
        {badge}
      </h6>
      <h2 className="text-lg font-titleFont text-strongColor font-medium">
        {title}
      </h2>
      <p className="text-sm text-designColor -mt-2">{subTitle}</p>
      {/* Below "lgl": clamp long descriptions to 3 lines (see .clamp-mobile
          in index.css) so one job entry doesn't dominate the accordion. At
          "lgl" and up: unchanged, full text. */}
      <p
        className="clamp-mobile text-base text-faintColor font-medium pr-0 lgl:pr-10"
        style={{ "--clamp-lines": 3 }}
      >
        {des}
      </p>
    </div>
  );
};

export default ResumeCard;
